import React from "react";
import { sanitizePhoneNumber, formatPhoneNumber } from "@/utils/phone/phoneUtils";

interface CallForAvailabilityProps {
    phone: string | null;
}

export const CallForAvailability = React.forwardRef<
    HTMLDivElement,
    CallForAvailabilityProps
>(({ phone }, ref) => {
    return (
        <div
            ref={ref}
            className="facility-call-availability"
            data-testid="callForAvailabilityButton"
        >
            Call for Availability <br />
            {phone && <a href={`tel:${sanitizePhoneNumber(phone)}`}>{formatPhoneNumber(phone)}</a>}
        </div>
    );
});

CallForAvailability.displayName = "CallForAvailability";
